import { buildHubDocumentTitleForRoute, integratorModuleKeyFromPathname } from "@/lib/hubDocumentMetadata";
import {
  HUB_APPLE_TOUCH_ICON_LINK_ID,
  HUB_FAVICON_LINK_ID,
} from "@/lib/hubBrowserTabTitle";
import { hubFaviconDataUri } from "@/lib/hubFaviconSvg";

function ensureLink(id: string, rel: string, type?: string): HTMLLinkElement {
  let link = document.getElementById(id) as HTMLLinkElement | null;
  if (link == null) {
    link = document.createElement("link");
    link.id = id;
    link.rel = rel;
    if (type != null) link.type = type;
    document.head.appendChild(link);
  }
  return link;
}

export interface ApplyHubDocumentMetadataInput {
  pathname: string;
  registeredPageLabel: string;
  moduleKey?: string | null;
  isDev?: boolean;
}

/** Update `document.title` and module favicon links for the current hub route. */
export function applyHubDocumentMetadata(input: ApplyHubDocumentMetadataInput): void {
  const isDev = input.isDev ?? import.meta.env.DEV;
  const resolvedModuleKey =
    input.moduleKey?.trim() ||
    integratorModuleKeyFromPathname(input.pathname) ||
    null;
  const title = buildHubDocumentTitleForRoute({
    pathname: input.pathname,
    registeredPageLabel: input.registeredPageLabel,
    moduleKey: resolvedModuleKey,
    isDev,
  });

  if (document.title !== title) {
    document.title = title;
  }

  const faviconHref = hubFaviconDataUri(resolvedModuleKey, isDev);
  const faviconLink = ensureLink(HUB_FAVICON_LINK_ID, "icon", "image/svg+xml");
  if (faviconLink.href !== faviconHref) {
    faviconLink.href = faviconHref;
  }

  const appleLink = ensureLink(HUB_APPLE_TOUCH_ICON_LINK_ID, "apple-touch-icon");
  if (appleLink.href !== faviconHref) {
    appleLink.href = faviconHref;
  }
}
